<button *ngFor="let localAction of localActions; let i = index;"
        [id]="'navigation-localaction-' + localAction.Id"
        [ngClass]="getClass(i)"
        [attr.data-controller]="localAction.controller"
        [disabled]="localAction.Disabled"
        (click)="handleLocalAction(localAction)">
  <span [tooltip]="localAction.NavigationToolTip">{{ localAction?.title | t }}</span>
</button>
